import MyBets from './component';

export default MyBets;
